import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'
import Cookies from 'universal-cookie'
import classNames from 'classnames'
import './Main.css'
import Logo from './logosafecash.png'

const cookies = new Cookies();

export default class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toogleActive: false,
      username: cookies.get('usernameKYCSafecash'),
      path: window.location.pathname
    }
  }

  handleLogout = () => {
    cookies.remove('tokenKYCSafecash', { path: '/'})
    cookies.remove('usernameKYCSafecash', { path: '/'})
    window.location.href = '/'
  }

  handleToggleMenu = () =>  this.setState({toogleActive: !this.state.toogleActive})

  render() {
    const { toogleActive, username, path } = this.state

    return (
      <div className="site">

        { /*Site Header*/ }
        <header className="site__header">
          <div className="toggle-menu" onClick={this.handleToggleMenu}>
            <span></span>
          </div>
          <div className="site__header__logo">
            <img src={Logo} alt="Safecash"/>
          </div>
          <div className="site__header__logout">
            <span className="userlogin">{`Hello, ${username}`}</span>
            <Icon name='power' size='large' onClick={this.handleLogout} title='Logout'/>
          </div>
        </header>

        { /*Site Sidebar*/ }
        <div className={toogleActive ? 'site__sidebar on' : 'site__sidebar'}>
          <div className="site__sidebar__inner" id="scroll-sidebar">
            <ul className="site__sidebar__menu">
              <li className={classNames({ active: path === '/' })}>
                <Link to="/"><Icon name='home' /> Dashboard</Link>
              </li>
              <li className={classNames({ active: path === '/verification' })}>
                <Link to="/verification"><Icon name='address card outline' /> Verificator</Link>
              </li>
              <li className={classNames({ active: path === '/datauser' })}>
                <Link to="/datauser"><Icon name='user' /> Search User</Link>
              </li>
            </ul>
          </div>
        </div>

        { /*Site Content*/ }
        <div className='site__content'>
          <div className='site__content__inner'>
            {this.props.children}
          </div>
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/Main.js